import { useEffect } from "react";
import { toast } from "sonner";

import type { ContinuityRecordSummary } from "@/lib/behavior/continuityRecord";
import {
  buildContinuityToastStorageKey,
  readLastAnnouncedContinuityMilestone,
  resolveContinuityToastAnnouncement,
  writeLastAnnouncedContinuityMilestone,
} from "@/lib/behavior/continuityMomentToast";

export function useContinuityMomentToast(params: {
  userId?: string | null;
  summary?: ContinuityRecordSummary | null;
  scopeId?: string | null;
  relationshipLeaderName?: string | null;
  enabled?: boolean;
}) {
  useEffect(() => {
    if (!params.enabled || !params.userId || !params.summary) return;
    if (typeof window === "undefined" || !window.localStorage) return;

    const kind = params.summary.label === "Leadership Record" ? "leadership" : "coaching";
    const storageKey = buildContinuityToastStorageKey({
      userId: params.userId,
      kind,
      scopeId: params.scopeId,
    });
    const lastAnnouncedMilestone = readLastAnnouncedContinuityMilestone(window.localStorage, storageKey);
    const announcement = resolveContinuityToastAnnouncement({
      summary: params.summary,
      lastAnnouncedMilestone,
      relationshipLeaderName: params.relationshipLeaderName,
    });
    if (!announcement) return;

    toast.message(announcement.copy.title, {
      description: announcement.copy.description,
      duration: 5000,
    });
    writeLastAnnouncedContinuityMilestone(window.localStorage, storageKey, announcement.milestone);
  }, [
    params.enabled,
    params.relationshipLeaderName,
    params.scopeId,
    params.summary,
    params.userId,
  ]);
}
